module.exports = __webpack_public_path__ + "static/BBB_logo_footer-66fd78181717c2b84f98e6b2b7b6cfd7.png";